export default __webpack_public_path__ + "static/media/organization2.1767321a.png";